// @flow

import { ACCOUNT_ON_CHANGE, LOGIN_FAILED, LOGIN_SUCCESS } from '../constants'

type State = {
  account: {
    account: string,
    password: string,
  },
  error: string,
}

type Action = {
  type: string,
  payload: any,
}

const initialState = {
  account: {
    account: '',
    password: ''
  },
  error: ''
}

function login(state: State = initialState, action: Action) {
  switch (action.type) {
    case ACCOUNT_ON_CHANGE:
      return {
        ...state,
        account: action.payload
      }
    case LOGIN_FAILED:
      return {
        ...state,
        error: action.payload
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        account: {
          account: '',
          password: ''
        }
      }
    default:
      return state
  }
}

export default login



// WEBPACK FOOTER //
// ./src/modules/login.js